export {ArticleOneColumn} from './lib/article-one-column';